import { render, staticRenderFns } from "./pdf-view.vue?vue&type=template&id=ea8c2406&"
import script from "./pdf-view.vue?vue&type=script&lang=js&"
export * from "./pdf-view.vue?vue&type=script&lang=js&"
import style0 from "./pdf-view.vue?vue&type=style&index=0&id=ea8c2406&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports